import HRXAttendance from './HRXAttendance';

export default HRXAttendance;
